import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { BulkLiteralsFacadeService } from 'src/app/shared/services/literals/bulk.literals.facade.service';
import { PaginatorLiteralsFacadeService } from 'src/app/shared/services/literals/paginator.literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { BulkHistoryFacadeService } from './bulk-history.facade.service';

@Injectable({ providedIn: 'root' })
export class BulkHistorySearchService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private paginatorFacade: PaginatorFacadeService,
    private bulkHistoryFacade: BulkHistoryFacadeService,
    private bulkLiterals: BulkLiteralsFacadeService,
    private literals: PaginatorLiteralsFacadeService,
  ) {}

  searchBulkHistory(): Observable<QcResponseGrid> {
    const url =
      this.environmentFacadeService.getEnvironment() +
      `/rest/v1/import/jobs/findByFilter?start=${
        this.paginatorFacade.pageIndex * 10
      }&pageSize=${this.paginatorFacade.itemsNumber}&sortField=${
        this.paginatorFacade.selectedSortField === this.bulkLiterals.importDate ? 'IMPORT_DATE' : 'IN_PROGRESS'
      }&sortOrder=${this.paginatorFacade.selectedOrder === this.literals.orderAsc ? 'ASC' : 'DESC'}`;

    const progress =
      this.bulkHistoryFacade.status === this.bulkLiterals.bulkInProgress
        ? true
        : this.bulkHistoryFacade.status === 'Complete'
          ? false
          : null;

    return this.http.post<QcResponseGrid>(
      url,
      {
        importDateFrom: this.bulkHistoryFacade.importDateFromFormat,
        importDateUntil: this.bulkHistoryFacade.importDateUntilFormat,
        inProgress: progress,
        importTitle: this.bulkHistoryFacade.configurationName,
      },
      { withCredentials: true, context: new HttpContext().set(IS_SEARCH, true) },
    );
  }
}
